module.exports = __webpack_public_path__ + "static/media/16.87d87cfa.jpg";